// extracted by mini-css-extract-plugin
export default {"image":"j2-z","loaded":"k2-z"};